"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
interface ApplicationItem {
  id: number;
  num: string;
  title: string;
  body: string;
  image: string;
  srcset: string;
  sizes: string;
  alt: string;
  imageLeft: boolean;
}
export default function Principles() {
  const container = useRef<HTMLDivElement>(null);
  const applications: ApplicationItem[] = [{
    id: 1,
    num: "01",
    title: "Limpeza de Lama de Bauxite",
    body: "A tecnologia de pulverização pode ajudar a automatizar a limpeza de lama de bauxite persistente, poupando tempo e dinheiro em mão de obra. Os especialistas da Spraying Systems Co. podem ajudá-lo a substituir o seu processo de limpeza manual por bicos TankJet 360® altamente eficazes. A remoção de lama de bauxite pode tornar-se dispendiosa e demorar um tempo prolongado. Habitualmente, a limpeza de lama de bauxite é feita com jato de água a alta pressão de forma manual, o que é ineficiente.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-18.37.50.png?v=7e3dqzt7n0u",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=21xgnlcqqbmi-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=s2lmqxgf3gl-wvc-sizes",
    alt: "Componente de engenharia industrial com acabamento metálico polido",
    imageLeft: true
  }, {
    id: 2,
    num: "02",
    title: "Limpeza das Passadeiras dos Tapetes Transportadoras",
    body: "Os especialistas da Spraying Systems Co. podem ajudar a prevenir problemas em correias transportadoras, como poeiras em suspensão, danos na correia e retorno de material (carryback), otimizando a configuração de pulverização para garantir que as partículas de poeira mais finas, frequentemente não removidas pelos raspadores, sejam eliminadas. Fragmentos finos de minério podem permanecer aderidos na parte inferior das correias transportadoras em vez de caírem.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-18.37.40.png?v=32ba1onmkum",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=hqfgzo1xsdt-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=14y4vhpa55o-wvc-sizes",
    alt: "Equipamento de pulverização industrial em ambiente de fábrica",
    imageLeft: false
  }, {
    id: 3,
    num: "03",
    title: "Controlo de Poeiras de Engenharia para Chutes de Mineração",
    body: "Na mineração, a fuga de poeiras em chutes de transferência compromete a segurança, aumenta o desgaste do equipamento e abranda a produção. Uma solução de pulverização de engenharia consegue a supressão ao combinar o tamanho de gota com o tamanho das partículas de poeira, através da seleção e posicionamento corretos dos bicos. Os controladores AutoJet® ou os controlos da instalação ativam as pulverizações apenas quando há presença de minério e fornecem alertas do sistema.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-18.37.27.png?v=am1mbtcd3oc",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=dhjd6gshrrm-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=b0shrkwao79-wvc-sizes",
    alt: "Sistema de controlo de pulverização automatizado em operação",
    imageLeft: true
  }, {
    id: 4,
    num: "04",
    title: "Soluções de Controlo e Poeiras em Transportadoras",
    body: "As unidades de processamento mineiro dispõem de correias transportadoras que transportam sólidos, como minério ou carvão, desde silos ROM ou pontos de transferência até ao processamento no local ou carregadores de navios. À medida que os sólidos se deslocam rapidamente na correia, as partículas de poeira levantam-se, gerando poeiras em suspensão, o que aumenta na presença de ventos predominantes. Os especialistas em Controlo de Poeiras da Spraying Systems Co. podem ajudar a maximizar a prevenção de poeiras, concebendo a configuração de pulverização correta para a sua unidade, de forma a garantir a máxima absorção e reduzir as emissões de poeiras sem causar problemas de produção.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-19.03.44.png?v=tb0dfv2eu0f",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=21xgnlcqqbmi-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=s2lmqxgf3gl-wvc-sizes",
    alt: "Componente de engenharia industrial com acabamento metálico polido",
    imageLeft: false
  }, {
    id: 5,
    num: "05",
    title: "Soluções de Filtragem na Mineração",
    body: "Previna o entupimento de bicos de pulverização, tempos de manutenção dispendiosos e danos em equipamentos com filtros e pacotes de filtragem personalizados pelos especialistas da Spraying Systems Co. As poeiras em suspensão são um dos principais problemas reportados em minas. Os bicos de pulverização utilizam água para suprimir e controlar as poeiras desde a mina até às operações portuárias, mas sem uma filtragem adequada, os bicos podem avariar e colocar a sua operação em risco ou criar custos desnecessários. A água utilizada é bombeada a partir de aquíferos subterrâneos ou água de processo reciclada, sendo transportada através de tubagens metálicas. Esta água apresenta elevado teor de cálcio, contaminantes de sujidade e fragmentos de corrosão provenientes do interior das tubagens, que podem bloquear parcial ou completamente os bicos de pulverização, tornando-os ineficazes e causando vários problemas durante as operações mineiras.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-19.03.49.png?v=ibnol2d7zib",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=hqfgzo1xsdt-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=14y4vhpa55o-wvc-sizes",
    alt: "Equipamento de pulverização industrial em ambiente de fábrica",
    imageLeft: true
  }, {
    id: 6,
    num: "06",
    title: "Pulverização de Tabuleiros de Escoamento (Launder Trays)",
    body: "Limpe e lave tabuleiros de escoamento com soluções de pulverização personalizadas pelos especialistas da Spraying Systems Co. Melhore a eficiência e a eficácia da sua pulverização para poupar tempo e dinheiro. Uma lavagem inadequada dos tabuleiros de escoamento pode conduzir a limpezas dispendiosas e a obstruções nas correias transportadoras, o que pode potencialmente resultar em incêndios na correia ou paragens de produção indesejadas. No entanto, ao utilizar a tecnologia de pulverização adequada, a sua empresa pode garantir que os resíduos são eficazmente removidos dos tabuleiros de escoamento, permitindo que o local continue a produção sem interrupções. Quando é utilizado o tipo de bico incorreto para a limpeza de tabuleiros de escoamento, não só a lavagem do derrame de minério é ineficaz, como também se consome quantidades excessivas de água. A Spraying Systems compreende que a lavagem de tabuleiros de escoamento tem de ser rápida e eficaz.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-07-as-19.03.55.png?v=4cjdcd3h6qx",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=dhjd6gshrrm-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=b0shrkwao79-wvc-sizes",
    alt: "Sistema de controlo de pulverização automatizado em operação",
    imageLeft: false
  }, {
    id: 7,
    num: "07",
    title: "Revestimentos de Vagões Ferroviários",
    body: "A tecnologia de pulverização é essencial para o controlo eficiente de poeiras em suspensão que se desprendem dos vagões ferroviários durante o transporte desde a mina até ao porto. Os especialistas da Spraying Systems Co. podem ajudar as minas a criar uma solução chave-na-mão que controlará as poeiras dos seus vagões. As poeiras que se desprendem de vagões carregados em trânsito desde a mina até ao porto causam três problemas principais que são extremamente perigosos, dispendiosos e exigem atenção especializada.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-10-as-14.05.29.png?v=yydad0d1h9",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=21xgnlcqqbmi-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=s2lmqxgf3gl-wvc-sizes",
    alt: "Componente de engenharia industrial com acabamento metálico polido",
    imageLeft: true
  }, {
    id: 8,
    num: "08",
    title: "Soluções Controlo Poeira em Silos ROM (ROM BIN)",
    body: "Independentemente do que está a ser descarregado em silos ROM — desde grandes blocos a pequenas rochas ou areia —, a necessidade de controlar as poeiras durante este processo de transferência é crítica. Os especialistas em controlo de poeiras da Spraying Systems Co. podem trabalhar com a sua unidade para criar um sistema de controlo de poeiras que controle eficazmente as poeiras em suspensão, sem excesso de humidade dispendioso nem problemas de manutenção.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-10-as-14.05.34.png?v=dgng2acxsye",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=hqfgzo1xsdt-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=14y4vhpa55o-wvc-sizes",
    alt: "Equipamento de pulverização industrial em ambiente de fábrica",
    imageLeft: false
  }, {
    id: 9,
    num: "09",
    title: "Soluções de Controlo de Poeiras em Pilhas de Armazenamento (SotckPile)",
    body: "As pilhas de armazenamento estão sempre presentes no setor da mineração e a necessidade de suprimir o excesso de poeiras devido a quedas, vento, recuperação e impacto é constante. A estabilização da superfície de uma pilha de armazenamento é crítica para aperfeiçoar a supressão de poeiras. Isto é conseguido através de rega regular, utilização correta de pulverização de água e posicionamento ideal. O controlo eficaz das poeiras das pilhas de armazenamento traz numerosos benefícios em termos de emissões, melhoria da saúde e condições dos trabalhadores e conformidade com as normas de emissões.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-10-as-14.05.39.png?v=ilr2xr44p1c",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=dhjd6gshrrm-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=b0shrkwao79-wvc-sizes",
    alt: "Sistema de controlo de pulverização automatizado em operação",
    imageLeft: true
  }];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".header-reveal", {
        y: 24
      });
      gsap.to(".header-reveal", {
        opacity: 1,
        y: 0,
        duration: 0.75,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      const rows = gsap.utils.toArray<HTMLElement>(".application-row");
      rows.forEach(row => {
        const content = row.querySelector(".row-content");
        const visual = row.querySelector(".row-visual");
        const num = row.querySelector(".row-num");
        if (content) gsap.set(content, {
          y: 32
        });
        if (visual) gsap.set(visual, {
          y: 32
        });
        if (num) gsap.set(num, {
          y: 20,
          scale: 0.95
        });
        const targets = [visual, content, num].filter(Boolean);
        gsap.to(targets, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.75,
          stagger: 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: row,
            start: "top 85%",
            once: true
          }
        });
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".header-reveal", ".row-content", ".row-visual", ".row-num"], {
        opacity: 1,
        y: 0,
        scale: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31279" id="controlo-poeiras-aplicacoes" data-nav="dark" className="relative bg-background text-foreground overflow-hidden py-[clamp(96px,12vh,168px)]">
      <div ref={container} className="relative mx-auto max-w-[1360px] px-5 sm:px-8 lg:px-16">
        {/* Header Block */}
        <div className="relative mx-auto max-w-3xl text-center">
          <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[380px] w-[640px] max-w-full rounded-lg blur-3xl opacity-25" style={{
          background: "radial-gradient(circle at center, hsl(215 90% 45% / 0.5), transparent 70%)"
        }} />
          <div className="header-reveal inline-flex items-center gap-2 rounded-lg border border-border bg-accent/40 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-secondary shadow-xs" style={{
          opacity: 0
        }}>
            Aplicações
          </div>

          <h2 className="header-reveal mt-5 font-default text-foreground text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.15]" style={{
          opacity: 0
        }}>
            Soluções de Controlo de Poeiras por Aplicação
          </h2>

          <p className="header-reveal mt-6 text-muted-foreground text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" style={{
          opacity: 0
        }}>
            Da extração ao transporte, cada etapa da operação mineira exige uma abordagem diferente ao controlo de poeiras. Conheça as nossas soluções de engenharia de pulverização para cada aplicação.
          </p>
        </div>

        {/* Vertical sequence of alternating items */}
        <div className="mt-16 sm:mt-24 space-y-14 sm:space-y-20 lg:space-y-28">
          {applications.map((item, i) => <article key={item.id} data-index={i} className="application-row relative rounded-2xl border border-border/80 bg-card p-6 sm:p-10 lg:p-12 shadow-sm transition-all duration-300 hover:border-secondary/30" style={{
          boxShadow: "inset 0 1px 0 hsl(0 0% 100% / 0.7)"
        }}>
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
                {/* Visual Block */}
                <div className={`row-visual lg:col-span-6 relative overflow-hidden rounded-xl border border-border bg-muted/30 ${item.imageLeft ? "lg:order-1" : "lg:order-2"}`} style={{
              opacity: 0
            }}>
                  <div className="relative aspect-[16/10] w-full overflow-hidden">
                    <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 ease-out hover:scale-105" />
                    <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
                  </div>
                </div>

                {/* Text Block */}
                <div className={`row-content lg:col-span-6 flex flex-col justify-center ${item.imageLeft ? "lg:order-2" : "lg:order-1"}`} style={{
              opacity: 0
            }}>
                  <div className="flex items-center justify-between gap-4 border-b border-border/70 pb-4 mb-5">
                    <span className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary">
                      Aplicação {item.num}
                    </span>
                    <span className="row-num text-3xl sm:text-4xl font-bold tracking-tight text-secondary/35 font-mono" style={{
                  opacity: 0
                }}>
                      {item.num}
                    </span>
                  </div>

                  <h3 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-foreground tracking-tight leading-snug">
                    {item.title}
                  </h3>

                  <p className="mt-4 text-sm sm:text-base text-muted-foreground leading-relaxed">
                    {item.body}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}